﻿document.addEventListener('DOMContentLoaded', function () {
    //packages tabs
    const omsTabSwitch = document.getElementById("omsTab");
    const ossTabSwitch = document.getElementById("ossTab");
    const omsPackagesDiv = document.getElementById("omsPackages");
    const ossPackagesDiv = document.getElementById("ossPackages");
    const solutionsPackagesDiv = document.getElementById("solutionsPackagesSection");
    const solutionsProducts = document.getElementById("solutionsProducts");

    if (omsTabSwitch && ossTabSwitch && omsPackagesDiv && ossPackagesDiv && solutionsPackagesDiv) {
        omsTabSwitch.addEventListener("click", function (e) {
            if (omsTabSwitch.classList.contains("selected")) return;
            omsTabSwitch.classList.add("selected");
            ossTabSwitch.classList.remove("selected");
            omsPackagesDiv.classList.add("selected");
            ossPackagesDiv.classList.remove("selected");
            solutionsPackagesDiv.classList.remove("ossBackground")
            solutionsPackagesDiv.classList.add("omsBackground")
        });

        ossTabSwitch.addEventListener("click", function (e) {
            if (ossTabSwitch.classList.contains("selected")) return;
            ossTabSwitch.classList.add("selected");
            omsTabSwitch.classList.remove("selected");
            ossPackagesDiv.classList.add("selected");
            omsPackagesDiv.classList.remove("selected");
            solutionsPackagesDiv.classList.remove("omsBackground")
            solutionsPackagesDiv.classList.add("ossBackground")
        });
    }

    //Scenarios blaze slider
    const scenariosSection = document.getElementById("scenariosSection");
    if (scenariosSection) {
        scenariosSection.classList.add("blaze-slider");
        new BlazeSlider(document.getElementsByClassName('blaze-slider')[0], {
            all: {
                enableAutoplay: false,
                draggable: false
            },
            '(max-width: 768px)': {
                draggable: true
            },
        });
    }

    //Remove Solutions-builder mini-banner
    const solutionsMiniBanner = document.querySelector(".solutions-mini-banner");
    const solutionsMiniBannerCloser = document.querySelector("div.solutions-mini-banner > a.close-box");

    if (solutionsMiniBanner && solutionsMiniBannerCloser) {
        //note this function will only work on a single mini-banner in the current page.
        solutionsMiniBannerCloser.addEventListener("click", function (e) {
            e.preventDefault(); //prevent page refresh.
            solutionsMiniBanner.classList.add("hidden-banner");
        });
    }

    //add click events and hrefs to packages buttons
    const omsButtons = document.querySelectorAll(".btnSolsOms");
    if (omsButtons) {
        omsButtons.forEach(function (button) {
            button.addEventListener("click", function (e) {
                e.preventDefault(); //prevent page refresh.
                window.location.href = "https://oms.optoma.com/";
            });
        });
    }

    const ossButtons = document.querySelectorAll(".btnSolsOss");
    if (ossButtons) {
        ossButtons.forEach(function (button) {
            button.addEventListener("click", function (e) {
                e.preventDefault(); //prevent page refresh.
                window.location.href = "https://whiteboard.optoma.com/";
            });
        });
    }

    if (solutionsProducts && solutionsProducts.childElementCount > 3) {
        solutionsProducts.style.maxWidth = '1260px';
        solutionsProducts.style.margin = 'auto';
    }
});